import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalReviewsRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/reviews",
  component: lazyRouteComponent(() => import("./reviews.page.js"), "PortalReviewsPage"),
});
